module.exports = __webpack_public_path__ + "img/ch-eco-vulnerability.241b39a2.jpg";